'use strict';

var _require = require('./app_link'),
    callOrDownload = _require.callOrDownload,
    callRightNow = _require.callRightNow,
    appType = _require.appType;

var isInBlackListFromClient = require('./black_list_from_client');
module.exports = {
  callOrDownload: callOrDownload,
  callRightNow: callRightNow,
  appType: appType,
  isInBlackListFromClient: isInBlackListFromClient
};